import { defineMessages } from 'react-intl';

const scope = 'app.component.PromoPrices.PopUp';

export default defineMessages({
  participantPrices: {
    id: `${scope}.participant_prices`,
    defaultMessage: 'Participant Prices'
  }
})